"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Modal = require("react-modal");
var DebtAcceptLitigationModalContent_1 = require("./components/DebtAcceptLitigationModalContent");
var DebtAcceptLitigationModal = function (props) {
    return (React.createElement("div", null,
        React.createElement(Modal, { isOpen: props.showModal, portalClassName: "modal" },
            React.createElement(DebtAcceptLitigationModalContent_1.default, __assign({}, props)))));
};
exports.default = DebtAcceptLitigationModal;
